import {
  WarningFilled_default
} from "./chunk-ZZJJELDV.mjs";
import {
  SuccessFilled_default
} from "./chunk-IWKPGHAY.mjs";
import {
  AlertFilled_default
} from "./chunk-T4QOMTQV.mjs";
import {
  cn
} from "./chunk-DYSUVPH5.mjs";

// src/components/field-message/field-message.tsx
import React from "react";
var FieldMessageIcon = ({ type }) => {
  switch (type) {
    case "critical":
      return /* @__PURE__ */ React.createElement(AlertFilled_default, { height: 16, width: 16 });
    case "success":
      return /* @__PURE__ */ React.createElement(SuccessFilled_default, { height: 16, width: 16 });
    default:
      return /* @__PURE__ */ React.createElement(WarningFilled_default, { height: 16, width: 16 });
  }
};
var FieldMessage = ({
  type,
  children
}) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cn("flex items-center space-x-[6px]", {
        "text-foreground": !type,
        "text-semantic-success-foreground-bold": type === "success",
        "text-semantic-critical-foreground-bold": type === "critical",
        "text-semantic-warning-foreground-bold": type === "warning"
      })
    },
    type && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(FieldMessageIcon, { type })),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cn({
          "my-body-xs": !type,
          "my-label-xs": type
        })
      },
      children
    )
  );
};

export {
  FieldMessage
};
